import React from 'react';
import PropTypes from 'prop-types';

import HeaderSection from '../../components/HeaderSection';
import SectionTitleWrapper from '../../components/SectionTitleWrapper';
import {
  DoubleCard,
  OperatorSection,
  ResponsibleSection,
  WideCard
} from './components';

const Imprint = ({
  contact,
  operator,
  copyright,
  responsible,
  euSettlement,
  header,
  titleSection,
  liabilityForContent,
  liabilityForLinks,
  universalSettlement
}) => (
  <>
    <HeaderSection {...header} />
    <section className="bg-white-100 container mx-auto px-4 space-y-4 pb-16">
      <SectionTitleWrapper {...titleSection} />
      <OperatorSection contact={contact} operator={operator} />
      <ResponsibleSection {...responsible} />
      <DoubleCard left={euSettlement} right={universalSettlement} />
      <WideCard {...copyright} />
      <DoubleCard left={liabilityForContent} right={liabilityForLinks} />
    </section>
  </>
);

Imprint.propTypes = {
  contact: PropTypes.object.isRequired,
  operator: PropTypes.object.isRequired,
  copyright: PropTypes.object.isRequired,
  responsible: PropTypes.object.isRequired,
  euSettlement: PropTypes.object.isRequired,
  header: PropTypes.object.isRequired,
  titleSection: PropTypes.object.isRequired,
  liabilityForContent: PropTypes.object.isRequired,
  liabilityForLinks: PropTypes.object.isRequired,
  universalSettlement: PropTypes.object.isRequired
};

export default Imprint;
